<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="false" />
    <v-snackbar v-model="showsnackbar" color="primary" right :timeout="timeout">
      {{msg}}
      <v-btn text @click="showsnackbar = false">
        <v-icon style="color:white;">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-dialog v-model="appConfirmation" width="500" persistent>
      <v-card>
        <v-card-title class="headline">
          <span style="font-size:16px;font-weight:600">Confirm here to change status as replied ?</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#00a972" text @click="appConfirmation = false">Cancel</v-btn>
          <v-btn color="red" text @click="changeMode">Change Status</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout wrap justify-center>
      <v-flex xs12 sm12 md12>
        <v-card id="app_height" outlined tile>
          <v-layout pa-4 wrap justify-center>
            <v-flex text-center>
              <span style="font-size:16px;font-weight:600">Applicant Details</span>
            </v-flex>
          </v-layout>
          
          <v-layout px-5 wrap justify-center align="center">
            <v-flex>
              <v-card>
                <table class="logtable" style width="100%" v-if="query != null">
                  <tr>
                    <th>Name</th>
                    <td>{{query.name}}</td>
                  </tr>

                  <tr>
                    <th>Email</th>
                    <td>{{query.email}}</td>
                  </tr>
                  <tr>
                    <th>Phone No</th>
                    <td>{{query.phonePrefix}} {{query.ph}}</td>
                  </tr>

                  <tr>
                    <th>Address</th>
                    <td>{{query.address}}</td>
                  </tr>
                    <tr>
                    <th>Applied To</th>
                    <td>{{query.career.careerName}}</td>
                  </tr>
                  <tr>
                    <th>Qualification</th>
                    <td>{{query.qualificationId.qualificationName}}</td>
                  </tr>

                  <tr>
                    <th>Experience</th>
                    <td>{{query.experienceId.experienceName}}</td>
                  </tr>

                  <tr>
                    <th>Resume</th>
                    <td>
                      <a
                        v-if="file"
                        target="_blank"
                        :href="'http://3.6.163.113/file/get/'+file"
                      >{{query.resume}}</a>
                    </td>
                  </tr>
                </table>
              </v-card>
            </v-flex>
          </v-layout>
          <!-- <v-flex v-if="query != null">
           
               <p v-if="query.status == 'new'">  <v-btn @click="checkFinal()" small text color="red" block>Click here to change status as Replied</v-btn></p>
                        <p v-else>  <v-btn small text color="green" block>Already Replied</v-btn></p>
          </v-flex>-->
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import VueElementLoading from "vue-element-loading";

export default {
  props: ["id"],
  components: {
    VueElementLoading,
  },
  data() {
    return {
      appConfirmation: false,
      appLoading: false,
      showsnackbar: false,
      timeout: 3000,
      msg: null,
      query: null,
      queryDate: null,
      file: null,
    };
  },
  beforeMount() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/application/view/details/" + this.id,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.data.status) {
            this.query = response.data.data;
            this.id = response.data.data._id;
            var dt = new Date(this.query.create_date);
            dt = dt.toString();
            dt = dt.slice(4, 25);
            this.queryDate = dt;
            if (this.query.resume != undefined) {
              this.file = this.query.resume;
            }
          } else {
            this.msg = response.data.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.msg = err.response.data.msg;
          this.showsnackbar = true;
        });
    },
    checkFinal: function () {
      this.appConfirmation = true;
    },
    changeMode: function () {
      this.appConfirmation = false;
      this.appLoading = true;
      var data = {};
      data["id"] = this.id;
      data["status"] = "replied";
      axios({
        method: "POST",
        url: "/query/status/",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: data,
      })
        .then((response) => {
          this.appLoading = false;
          this.getQuery();
          this.msg = response.data.msg;
          this.showsnackbar = true;
        })
        .catch((err) => {
          this.appLoading = false;
          this.msg = err.response.data.msg;
          this.showsnackbar = true;
        });
    },
  },
};
</script>
<style>
@media only screen and (min-width: 800px) {
  #app_height {
    min-height: 80vh;
    min-width: 80vw;
  }
}
.logtable,
.logtable th,
.logtable td {
  border: 1px solid black;
  border-collapse: collapse;
}
.logtable .logtable th,
.logtable td {
  padding: 5px;
  padding-left: 20px;
  text-align: left;
}
.logtable th {
  text-align: left;
  padding: 5px;
  padding-left: 50px;
  max-width: 80px;
}
</style>